import { useState, useEffect, useRef, useContext } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Flex,
    Box,
    Text,
    Textarea,
    IconButton,
    Image,
    useDisclosure,
} from "@chakra-ui/react";
import Thread from "components/tweets/masonry/thread";
import { cancelPostPublishActions } from "controllers/schedule";
import { hasAdvancedOptions } from "utils/tweetUtils";
import { AiOutlineSend } from "react-icons/ai";
import { useSession } from "next-auth/react";
import toast from "react-hot-toast";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { firebaseClient, getToken } from "firebaseClient";
import { approve, reject } from "controllers/ghostController";
import { ConfirmPopup } from "components/popups/confirmPopup";
import { TweetContext } from "context/tweetContext";

interface Props {
    tweet: any;
    isGhostwriter?: boolean;
    onClose?: Function;
}

export function DialogBox({ tweet, isGhostwriter = false, onClose }: Props) {

    const [text, setText] = useState("");
    const [messages, setMessages] = useState<any>([]);
    const { data: session } = useSession() ?? {};
    const isAuthenticated = useFirebaseUser();
    const dialogRef = useRef<any>(null);
    const {
        isOpen: isOpenApprove,
        onOpen: onOpenApprove,
        onClose: onCloseApprove,
    } = useDisclosure();
    const {
        isOpen: isOpenRevision,
        onOpen: onOpenRevision,
        onClose: onCloseRevision,
    } = useDisclosure();
    const tweetContext: any = useContext(TweetContext);

    const sendMessage = async function () {
        if (!session?.user?.uid) {
            toast.error("Session not properly initialized")
            return;
        }

        let account = session.user.data.accounts?.[0];

        let dataToSave = {
            dateCreated: new Date(),
            text,
            idUser: session.user.uid,
            user: {
                image: account?.image,
                twUserName: account?.username,
                name: account?.name,
                id: session.user.uid,
            }
        }

        messages.push(dataToSave);
        setMessages([...messages]);
        setText("");
        scrollToBottom();

        console.log("sendMEssage")

        const response = await fetch('/api/ghostwriting/tweetMessageNotifUpdate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                tokenUserId: session?.user?.uid,
                token: await getToken(session, "approveIteration"),
                tweet,
                idUser: session?.user?.uid,
            }),
        });

        const db = firebaseClient.firestore();
        await db.collection("users").doc(tweet.idUser).collection("tweets").doc(tweet.id).collection("messages").add(dataToSave);
    }

    const listenToUpdates = async function () {
        const db = firebaseClient.firestore();
        await db.collection("users").doc(tweet.idUser).collection("tweets").doc(tweet.id).collection("messages").onSnapshot((querySnapshot) => {
            console.log("new message");
            getMessages();
        });
    }

    const getMessages = async function () {
        const db = firebaseClient.firestore();
        let docs = await db.collection("users").doc(tweet.idUser).collection("tweets").doc(tweet.id).collection("messages").orderBy("dateCreated", "asc").get();
        let messagesFetched = docs.docs.map(x => { return { ...x.data(), id: x.id } });
        setMessages(messagesFetched);

        if (messagesFetched.length > 2)
            scrollToBottom();

        const response = await fetch('/api/ghostwriting/tweetMessageNotifUpdate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                tokenUserId: session?.user?.uid,
                token: await getToken(session, "approveIteration"),
                tweet,
                idUser: session?.user?.uid,
                isReset: true,
            }),
        });
    }

    const scrollToBottom = async function () {
        await new Promise(resolve => setTimeout(resolve, 200));
        dialogRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }

    useEffect(() => {
        if (isAuthenticated) {
            getMessages();
            listenToUpdates();
        }
    }, [isAuthenticated]);


    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
            sendMessage();
        }
    }

    let status = "draft";
    if (tweet.statusGhost == "pending") {
        status = "pending client validation";
    }
    if (tweet.statusGhost == "done" || tweet.statusGhost == "ready") {
        status = "client validated the content";
    }
    if (tweet.statusGhost == "rejected") {
        status = "revision requested";
    }

    const displayStatus = () => {
        if (isGhostwriter) {
            return (
                <Flex mt={5} alignItems="center" justifyContent="flex-end">
                    <Text fontWeight="400" mr={2}><b>{status}</b></Text>
                    {
                        tweet.statusGhost == "rejected" && (
                            <Button
                                colorScheme="twitter"
                                ml={3}
                                onClick={() => {
                                    tweetContext.newTweet(tweet, tweet.id);
                                    tweetContext.setIsTweetTextChanged(true);
                                    tweetContext.open();
                                    onClose && onClose();
                                }}
                            >
                                Submit Revision
                            </Button>
                        )
                    }
                </Flex>
            )
        }
        else if (["approved", "ready"].includes(tweet.statusGhost)) {
            return (
                <Flex mt={5} w="100%" justifyContent="center">
                    content validated ✅
                </Flex>
            );
        }
        else if (["rejected"].includes(tweet.statusGhost)) {
            return (
                <Flex mt={5} w="100%" fontWeight={600} justifyContent="center">
                    pending revision...
                </Flex>
            );
        }
        else {
            return (
                <Flex mt={10} w="100%" justifyContent="center">
                    <Button
                        colorScheme="red"
                        variant="secondaryDestructive"
                        mr={3}
                        onClick={() => onOpenRevision()}
                    >
                        ask for a revision
                    </Button>
                    <Button
                        variant="primary"
                        mr={3}
                        onClick={() => onOpenApprove()}
                    >
                        Approve
                    </Button>
                </Flex>
            )
        }

    }

    console.log("isGhostwriter", isGhostwriter);

    return (
        <Flex flexDir="column" >
            <Text fontWeight="600" mb={2}>Collaborate on this post</Text>

            <Flex flexDir="column" maxH="calc(90vh - 300px)" overflowY="auto">
                {
                    messages?.map((message, index) => (
                        <Flex mt={2} key={index} p={2} bg="gray.50" rounded="lg">
                            <Image src={message.user.image} w="8" h="8" rounded="full" />
                            <Flex ml={2} flexDir="column">
                                <Text fontWeight={600} >{message.user.name}</Text>
                                <Text whiteSpace="pre-line">{message.text}</Text>
                            </Flex>
                        </Flex>
                    ))
                }
                <Box ref={dialogRef} />
            </Flex>

            <Box mt={5} position="relative">
                <Textarea
                    pb={10} value={text}
                    onChange={(e) => setText(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <IconButton position="absolute"
                    bottom="5px"
                    right="5px" aria-label="send-message"
                    variant="ghost"
                    zIndex={10}
                    icon={<AiOutlineSend fontSize="16px" />}
                    onClick={sendMessage}
                />
            </Box>

            {displayStatus()}

            <ConfirmPopup
                isOpen={isOpenApprove}
                onClose={onCloseApprove}
                title="Ready to approve?"
                allowClickBackground={true}
                body={"You cannot change an approved content’s status. Please make sure you’re satisfied with the current state of the content."}
                callback={async () => {
                    await approve(tweet)
                    tweetContext.refresher({});
                }}
            />
            <ConfirmPopup
                isOpen={isOpenRevision}
                onClose={onCloseRevision}
                title="Requesting a new revision?"
                allowClickBackground={true}
                body={"Please make sure you have communicated useful feedback to the writer so they can improve the content."}
                callback={async () => {
                    if (messages?.length > 0) {
                        await reject(tweet);
                        tweetContext.refresher({});
                    }
                    else
                        toast.error("You need to send at least one message to ask for a revision");
                }}
            />
        </Flex>
    );
}
